var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"os-avatar",attrs:{"size":_vm.size,"color":_vm.color}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }